import { render, staticRenderFns } from "./FormsOfPayment.vue?vue&type=template&id=593ffac5&scoped=true"
import script from "./FormsOfPayment.vue?vue&type=script&lang=js"
export * from "./FormsOfPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593ffac5",
  null
  
)

export default component.exports